import BlogAiHealthImage from "../imgs/blog/inteligencia-artificial-y-profesiones-de-la-salud-fundacion-nican.png";

const blogPosts = [
  {
    slug: "inteligencia-artificial-profesiones-salud-cuidado-personas",
    title:
      "La Inteligencia Artificial cambiara muchos trabajos, pero todavia no puede cuidar de una persona",
    metaTitle:
      "IA y profesiones de salud: por que el cuidado humano sigue siendo indispensable | Fundacion Nican",
    metaDescription:
      "La inteligencia artificial transformara muchos empleos, pero las profesiones de salud, bienestar y cuidado humano siguen necesitando practica, criterio y trato humano.",
    excerpt:
      "La IA puede explicar procedimientos, pero no puede sostener la mano de un paciente, aplicar una inyeccion o brindar una terapia real.",
    date: "2026-06-27",
    image: BlogAiHealthImage,
    imageAlt:
      "Inteligencia artificial y profesiones de la salud en Fundacion Nican",
    content: [
      {
        type: "p",
        text: "Durante los ultimos anos hemos visto como la Inteligencia Artificial ha transformado industrias completas.",
      },
      {
        type: "p",
        text: "Hoy existen herramientas capaces de redactar documentos, traducir idiomas, generar imagenes, escribir codigo, analizar datos e incluso responder preguntas complejas en cuestion de segundos.",
      },
      {
        type: "p",
        text: "Esto ha generado una preocupacion legitima: ¿mi profesion seguira existiendo dentro de algunos anos?",
      },
      {
        type: "p",
        text: "La respuesta es que muchas actividades cambiaran, especialmente aquellas basadas en tareas repetitivas o administrativas.",
      },
      {
        type: "p",
        text: "Sin embargo, existe un grupo de profesiones cuyo valor va mucho mas alla del conocimiento tecnico. Son profesiones donde la confianza, la empatia, el contacto humano y la habilidad practica siguen siendo esenciales.",
      },
      {
        type: "h2",
        text: "La Inteligencia Artificial puede explicar un procedimiento...",
      },
      {
        type: "p",
        text: "ChatGPT puede explicar como aplicar un vendaje. Puede describir los pasos para administrar un medicamento. Puede ayudarte a estudiar anatomia. Puede responder dudas sobre rehabilitacion fisica.",
      },
      {
        type: "p",
        text: "Pero no puede hacerlo por ti. No puede sostener la mano de un paciente nervioso. No puede detectar con sensibilidad el dolor que una persona intenta ocultar. No puede brindar tranquilidad a una familia preocupada.",
      },
      {
        type: "p",
        text: "Y definitivamente no puede realizar procedimientos fisicos que requieren precision, experiencia y responsabilidad.",
      },
      {
        type: "h2",
        text: "Hay habilidades que siguen dependiendo de las personas",
      },
      {
        type: "p",
        text: "Imagina por un momento una consulta medica. ¿Confiarias en que una Inteligencia Artificial aplicara una inyeccion? ¿Que cambiara un cateter? ¿Que realizara un masaje terapeutico? ¿Que ayudara fisicamente a una persona durante un proceso de rehabilitacion?",
      },
      {
        type: "p",
        text: "La respuesta es evidente. La tecnologia puede convertirse en una gran herramienta de apoyo. Pero el cuidado de las personas sigue necesitando personas.",
      },
      {
        type: "h2",
        text: "Las profesiones relacionadas con la salud seguiran siendo indispensables",
      },
      {
        type: "p",
        text: "Mientras la tecnologia avanza, tambien aumenta la necesidad de profesionales capacitados que sepan combinar el conocimiento con la atencion humana.",
      },
      {
        type: "list",
        items: [
          "Auxiliar de Enfermeria",
          "Quiropractica",
          "Masoterapia",
          "Rehabilitacion Fisica",
          "Certificaciones profesionales en salud",
        ],
      },
      {
        type: "p",
        text: "Estas areas continuan representando oportunidades reales de desarrollo profesional. No solo permiten encontrar empleo; tambien ofrecen la posibilidad de emprender y brindar servicios especializados a la comunidad.",
      },
      {
        type: "h2",
        text: "La mejor estrategia frente a la Inteligencia Artificial",
      },
      {
        type: "p",
        text: "La pregunta correcta no es: ¿como competir contra la IA? La verdadera pregunta es: ¿como trabajar junto con ella?",
      },
      {
        type: "p",
        text: "Los profesionales que tendran mayor exito seran aquellos que utilicen herramientas digitales para aprender mas rapido, organizar mejor su trabajo y mantenerse actualizados, sin perder aquello que ninguna maquina puede reemplazar.",
      },
      {
        type: "list",
        items: [
          "La empatia.",
          "La etica.",
          "El juicio profesional.",
          "La experiencia practica.",
          "El trato humano.",
        ],
      },
      {
        type: "h2",
        text: "La formacion profesional sigue siendo una de las mejores inversiones",
      },
      {
        type: "p",
        text: "En Fundacion Nican creemos que aprender una profesion no solo significa adquirir conocimientos. Significa desarrollar habilidades que pueden transformar tu futuro y el de las personas que atenderas.",
      },
      {
        type: "p",
        text: "Cada alumno representa una historia distinta. Algunos buscan conseguir su primer empleo. Otros desean emprender. Muchos simplemente quieren crecer profesionalmente.",
      },
      {
        type: "p",
        text: "Todos tienen algo en comun: estan preparandose para desempenar actividades donde el valor humano continua siendo indispensable.",
      },
      {
        type: "h2",
        text: "El futuro pertenece a quienes aprenden",
      },
      {
        type: "p",
        text: "La Inteligencia Artificial seguira evolucionando. Y eso es una excelente noticia. Nos permitira aprender mejor, trabajar con mayor eficiencia y ofrecer mejores servicios.",
      },
      {
        type: "p",
        text: "Pero seguira necesitando profesionales preparados que sepan convertir ese conocimiento en acciones reales. Porque una computadora puede explicar un procedimiento. Pero solo una persona capacitada puede cambiar una vida.",
      },
      {
        type: "cta",
        title: "¿Quieres desarrollar una profesion con impacto real?",
        text: "En Fundacion Nican ofrecemos cursos y certificaciones profesionales en areas de la salud y el bienestar, impartidos por especialistas con experiencia y orientados a desarrollar competencias que siguen siendo altamente valoradas en el mercado laboral.",
        linkText: "Conoce nuestros programas",
        linkHref: "/#certificaciones",
      },
    ],
  },
  {
    slug: "como-convertirte-en-auxiliar-de-enfermeria-en-mexico",
    title: "¿Cómo convertirte en auxiliar de enfermería en México?",
    metaTitle:
      "Cómo convertirte en auxiliar de enfermería en México | Fundación Nican",
    metaDescription:
      "Conoce qué estudiar, qué habilidades necesitas y cómo iniciar tu formación como auxiliar de enfermería en México.",
    excerpt:
      "Una guía inicial para entender qué hace un auxiliar de enfermería, qué habilidades necesita y cómo empezar una formación profesional.",
    content: [
      "Convertirte en auxiliar de enfermería puede ser una ruta profesional para integrarte al sector salud, apoyar a pacientes y desarrollar habilidades prácticas con alta demanda.",
      "El primer paso es buscar una formación que incluya fundamentos de enfermería, anatomía, atención al paciente, procedimientos básicos y práctica supervisada.",
      "En Ixtapaluca y la zona oriente del Estado de México, esta formación puede abrir oportunidades en clínicas, campañas de salud, instituciones de cuidado y servicios particulares.",
    ],
  },
  {
    slug: "certificaciones-sep-para-conseguir-trabajo",
    title: "5 certificaciones SEP que te ayudan a conseguir trabajo",
    metaTitle:
      "5 certificaciones SEP para conseguir trabajo | Fundación Nican",
    metaDescription:
      "Descubre cómo una certificación SEP-CONOCER puede fortalecer tu perfil profesional y mejorar tus oportunidades laborales.",
    excerpt:
      "Las certificaciones laborales ayudan a demostrar competencias y pueden mejorar la confianza de empleadores o clientes.",
    content: [
      "Una certificación SEP-CONOCER puede ayudarte a demostrar que tienes competencias evaluadas bajo un estándar reconocido.",
      "Algunas opciones útiles están relacionadas con atención al paciente, capacitación, diseño de cursos, formación virtual y servicios de bienestar.",
      "Para elegir bien, revisa si la certificación se relaciona con tu experiencia, tu objetivo laboral y las oportunidades disponibles en tu zona.",
    ],
  },
  {
    slug: "vale-la-pena-estudiar-quiropractica-en-2026",
    title: "¿Vale la pena estudiar quiropráctica en 2026?",
    metaTitle:
      "¿Vale la pena estudiar quiropráctica en 2026? | Fundación Nican",
    metaDescription:
      "Analiza oportunidades de formación, autoempleo y servicios de bienestar al estudiar quiropráctica en México.",
    excerpt:
      "La quiropráctica puede ser una opción para quienes buscan trabajar en bienestar físico, rehabilitación y servicios terapéuticos.",
    content: [
      "Estudiar quiropráctica en 2026 puede ser valioso si buscas desarrollar habilidades enfocadas en bienestar físico, movilidad y atención terapéutica.",
      "La demanda de servicios relacionados con salud y bienestar sigue creciendo, especialmente para personas que quieren emprender o complementar una formación previa.",
      "Un diplomado con enfoque práctico puede ayudarte a ganar seguridad, criterio profesional y herramientas para atender necesidades comunes del cuerpo.",
    ],
  },
  {
    slug: "iniciar-negocio-terapias-fisicas-mexico",
    title: "Cómo iniciar tu negocio de terapias físicas en México",
    metaTitle:
      "Cómo iniciar un negocio de terapias físicas en México | Fundación Nican",
    metaDescription:
      "Aprende qué necesitas para iniciar servicios de terapias físicas, masoterapia o bienestar corporal en México.",
    excerpt:
      "Emprender en terapias físicas requiere formación, práctica, confianza y una propuesta clara para tus primeros clientes.",
    content: [
      "Iniciar un negocio de terapias físicas empieza con una formación sólida y práctica. Antes de vender servicios, necesitas entender anatomía, técnicas, límites y atención segura.",
      "Después, define qué servicio ofrecerás: masoterapia, rehabilitación básica, bienestar corporal, apoyo físico o atención preventiva.",
      "También necesitas presencia local. En lugares como Ixtapaluca, Chalco y Valle de Chalco, una estrategia de recomendaciones, reseñas y Google Business Profile puede ayudarte a conseguir tus primeros clientes.",
    ],
  },
];

export default blogPosts;
